module.exports = __webpack_public_path__ + "static/img/event_people.11a8a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelNew/event_people.png
// module id = l44S
// module chunks = 1